import type { CSSProperties } from "react";
import styles from "./headerBanner.module.scss";
import { useBreakLG } from "@monta/design-system";
import type { IHeaderBanner } from "../constants";

export interface HeaderBannerProps {
  headerBanner: IHeaderBanner;
}

const HeaderBanner = (props: HeaderBannerProps) => {
  const { headerBanner } = props;
  const breakLg = useBreakLG();
  const imageStyle: CSSProperties = {
    position: "absolute",
    height: "100%",
    width: "100%",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    objectFit: "cover",
    objectPosition: "center",
  };
  return (
    <div className={styles["header-banner"]}>
      {breakLg ? (
        <img
          src={headerBanner?.desktopImage?.data?.attributes?.url}
          alt={"desktop-banner"}
          style={imageStyle}
        />
      ) : (
        <img
          src={headerBanner?.mobileImage?.data?.attributes?.url}
          alt={"mobile-banner"}
          style={imageStyle}
        />
      )}
    </div>
  );
};

export default HeaderBanner;
